import{css}from'glamor';export var noGap=css({marginBottom:0,background:'none'}).toString();